import { render, staticRenderFns } from "./editStoreMsg.vue?vue&type=template&id=448c575c"
import script from "./editStoreMsg.vue?vue&type=script&lang=js"
export * from "./editStoreMsg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports